import { type BaseOptionType } from "antd/lib/select"

/** Case- and whitespace-insensitive comparison key for a party name. */
export const normalize = (str: string) =>
  str.toLowerCase().replace(/\s+/g, " ").trim()

/**
 * Merges any number of option lists into a searchable, editable free-text party
 * list, stored by name and deduped.
 */
export function buildStakeholderOptions(
  ...lists: Array<BaseOptionType[] | undefined>
): BaseOptionType[] {
  const seen = new Set<string>()
  const out: BaseOptionType[] = []
  for (const list of lists) {
    for (const option of list ?? []) {
      const name = String(option.label ?? "")
      if (!name || seen.has(name)) continue
      seen.add(name)
      out.push({ value: name, label: name })
    }
  }
  return out
}
